import React from "react";
import PropTypes from "prop-types";
import { RecordsTable } from "dyl-components";
import Header from "./Header";
import Row from "./Row";
import { useSelector } from "react-redux";

const Table = ({ isColumnHidden, onEdit, onDelete, onAdd }) => {
    const { listOfTagCategories, isGettingListOfTagCategories } = useSelector(
        (state) => state?.tag_categories
    );

    return (
        <RecordsTable
            tableBodyClassName="TagsTable"
            isTableLoading={isGettingListOfTagCategories}
            isTableEmpty={!listOfTagCategories?.length}
            TableHeader={<Header isColumnHidden={isColumnHidden} />}
            TableRows={listOfTagCategories?.map?.((category) => (
                <Row
                    key={category?.id}
                    record={category}
                    isColumnHidden={isColumnHidden}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            ))}
            recordsName="Call Tag"
            hasPagination={false}
            onClick={onAdd}
        />
    );
};

Table.propTypes = {
    isColumnHidden: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onAdd: PropTypes.func.isRequired,
};

export default Table;
